import { apiSlice } from 'src/app/redux/api/apiSlice';
import { FileUploadDataType } from 'src/app/redux/fileUpload/fileUpload-slice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const fileUploadSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<void, FileUploadDataType>({
      query: (data) => ({
        url: finalUrlsConfig().fileUpload,
        body: data,
        method: 'POST',
      }),
    }),
  }),
});

export const { useUploadFileMutation } = fileUploadSlice;
